import { useRef, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { Upload, X, Loader2 } from "lucide-react";
import StockPhotoPicker from "./admin/StockPhotoPicker";

/**
 * ImageUpload — uploads to /api/uploads (user) or /api/admin/uploads (admin).
 * onChange receives the public URL.
 */
export default function ImageUpload({ value, onChange, endpoint = "/uploads", testId = "image-upload", stock = true, stockQuery = "", plantId = "" }) {
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);
  const backend = process.env.REACT_APP_BACKEND_URL;

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setLoading(true);
    const fd = new FormData();
    fd.append("file", f);
    try {
      const r = await api.post(endpoint, fd, { headers: { "Content-Type": "multipart/form-data" } });
      // url is like /api/files/{path} — turn into absolute for storage in DB
      const absolute = backend + r.data.url;
      onChange(absolute);
      toast.success("Bild hochgeladen");
    } catch (err) {
      toast.error("Upload fehlgeschlagen");
    } finally {
      setLoading(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div className="space-y-2" data-testid={testId}>
      {value ? (
        <div className="relative inline-block">
          <img src={value} alt="upload" className="h-32 w-32 object-cover rounded-xl border" style={{ borderColor: "var(--wp-border)" }} />
          <button type="button" onClick={() => onChange("")} className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-white border flex items-center justify-center hover:bg-red-50" data-testid={`${testId}-clear`}>
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      ) : (
        <label className="cursor-pointer inline-flex items-center gap-2 px-4 py-3 rounded-xl border-2 border-dashed text-sm hover:border-[var(--wp-primary)]" style={{ borderColor: "var(--wp-border)" }}>
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          {loading ? "Lädt hoch…" : "Bild hochladen"}
          <input ref={ref} type="file" accept="image/*" onChange={handle} className="hidden" disabled={loading} data-testid={`${testId}-input`} />
        </label>
      )}
      {stock && endpoint.startsWith("/admin") && (
        <StockPhotoPicker onImported={(url) => onChange(url)} query={stockQuery} plantId={plantId} label="Stockfoto suchen (Wikimedia / Pexels)" />
      )}
    </div>
  );
}
